<template>
   <div>
      <v-layout wrap>
         <v-flex xs12>
            <span class="myheader pt-5"> Lead Info</span>
            <v-divider></v-divider>
         </v-flex>
         <v-flex xs12>
         </v-flex>


         <!--------------------additional lead info-------------------->

         <v-flex xs12 sm6 md6 class="myforminput">
            <v-text-field
                label="Customer's First Name*"
                v-model="form.info_cust.name_first"
                :rules="[x=>isRequired(x, 'Customer Name')]"
                @change="check_duplicate_lead"
            ></v-text-field>
         </v-flex>
         <v-flex xs12 sm6 md6 class="myforminput">
            <v-text-field
                label="Customer's Last Name*"
                v-model="form.info_cust.name_last"
                :rules="[x=>isRequired(x, 'Customer Name')]"
                @change="check_duplicate_lead"
            ></v-text-field>
         </v-flex>

         <v-flex xs12 sm6 md6 class="myforminput">
            <v-text-field
                label="Vehicle of Interest*"
                v-model="form.info_lead.wanted_vehicle"
                :rules="[x=>isRequired(x, 'Vehicle')]"
            ></v-text-field>
         </v-flex>

         <v-flex xs12 sm6 md6 class="myforminput">
            <v-text-field
                label="Lead Source*"
                v-model="form.info_lead.lead_source"
                :rules="[x=>isRequired(x, 'Lead source')]"
            ></v-text-field>
         </v-flex>


         <!--------------lead in crm date-------------------------->
         <v-flex xs12 sm4 md4 class="myforminput">
            <v-menu
                v-model="date_menu1"
                :close-on-content-click="false"
                :nudge-right="0"
                lazy
                transition="scale-transition"
                offset-y
                :nudge-bottom="picker_nudge"
                full-width
                max-width="290px"
                min-width="290px"
            >
               <template v-slot:activator="{ on }">
                  <v-text-field
                      v-model="form.info_lead.lead_arrived_date"
                      label="Date Lead Arrived in CRM*"
                      hint="YYYY-MM-DD format"
                      prepend-icon="event"
                      v-on="on"
                      :rules="[x=>isRequired(x, 'Date')]"
                      readonly
                  ></v-text-field>
               </template>
               <v-date-picker
                   v-model="form.info_lead.lead_arrived_date"
                   @input="date_menu1 = false"
                   no-title
                   @change="check_duplicate_lead"
               ></v-date-picker>
            </v-menu>
         </v-flex>

         <!--------------lead in crm time-------------------------->
         <v-flex xs12 sm4 md4 class="myforminput">
            <v-menu
                v-model="time_menu1"
                :close-on-content-click="false"
                :nudge-right="0"
                :nudge-bottom="picker_nudge"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
            >
               <template v-slot:activator="{ on }">
                  <v-text-field
                      v-model="form.info_lead.lead_arrived_time"
                      label="Time Lead Arrived in CRM*"
                      hint="hh:mm 24 format"
                      prepend-icon="access_time"
                      v-on="on"
                      readonly
                      :rules="[x=>isRequired(x, 'Time')]"
                  ></v-text-field>
               </template>
               <v-time-picker v-model="form.info_lead.lead_arrived_time" ></v-time-picker>
            </v-menu>
         </v-flex>


         <v-flex grow></v-flex>
         <v-flex md1></v-flex>

         <!--------------email response date -------------------------->
         <v-flex xs12 sm4 md4 class="myforminput">
            <v-menu
                v-model="date_menu2"
                :close-on-content-click="false"
                :nudge-right="0"
                :nudge-bottom="picker_nudge"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
            >
               <template v-slot:activator="{ on }">
                  <v-text-field
                      v-model="form.info_lead.email_response_date"
                      label="Date Personal Email Response*"
                      hint="YYYY-MM-DD format"
                      prepend-icon="event"
                      v-on="on"
                      readonly
                      :disabled="form.info_lead.no_email_received"
                      :rules="[x=>isRequired(x, 'Date', form.info_lead.no_email_received)]"
                      ref="email_resp_date"
                  ></v-text-field>
               </template>
               <v-date-picker v-model="form.info_lead.email_response_date" no-title  @input="date_menu2 = false"></v-date-picker>
            </v-menu>
         </v-flex>



         <!--------------email response time -------------------------->
         <v-flex xs12 sm4 md4 class="myforminput">
            <v-menu
                v-model="time_menu2"
                :close-on-content-click="false"
                :nudge-right="0"
                :nudge-bottom="picker_nudge"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
            >
               <template v-slot:activator="{ on }">
                  <v-text-field
                      label="Time Personal Email Response*"
                      v-model="form.info_lead.email_response_time"
                      hint="hh:mm 24 format"
                      prepend-icon="access_time"
                      v-on="on"
                      readonly
                      :disabled="form.info_lead.no_email_received"
                      :rules="[x=>isRequired(x, 'Time', form.info_lead.no_email_received)]"
                      ref="email_resp_time"
                  ></v-text-field>
               </template>
               <v-time-picker v-model="form.info_lead.email_response_time"  ></v-time-picker>
            </v-menu>
         </v-flex>

         <v-flex grow>

            <v-checkbox
                label="Check if no email received"
                v-model="form.info_lead.no_email_received"
                v-on:change="$refs.email_resp_time.resetValidation(); $refs.email_resp_date.resetValidation()"
            >
            </v-checkbox>
         </v-flex>


         <!--------------Phone response date -------------------------->
         <v-flex xs12 sm4 md4 class="myforminput">
            <v-menu
                v-model="date_menu3"
                :close-on-content-click="false"
                :nudge-right="0"
                :nudge-bottom="picker_nudge"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
            >
               <template v-slot:activator="{ on }">
                  <v-text-field
                      v-model="form.info_lead.phone_response_date"
                      label="Date of First Phone Call*"
                      hint="YYYY-MM-DD format"
                      prepend-icon="event"
                      v-on="on"
                      readonly
                      :disabled="form.info_lead.no_call_received"
                      :rules="[x=>isRequired(x, 'Date', form.info_lead.no_call_received)]"
                      ref="phone_resp_date"
                  ></v-text-field>
               </template>
               <v-date-picker v-model="form.info_lead.phone_response_date" no-title @input="date_menu3 = false"></v-date-picker>
            </v-menu>
         </v-flex>



         <!--------------Phone response time -------------------------->
         <v-flex xs12 sm4 md4 class="myforminput">
            <v-menu
                v-model="time_menu3"
                :close-on-content-click="false"
                :nudge-right="0"
                :nudge-bottom="picker_nudge"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
            >
               <template v-slot:activator="{ on }">
                  <v-text-field
                      v-model="form.info_lead.phone_response_time"
                      label="Time First Phone Call*"
                      hint="hh:mm 24 format"
                      prepend-icon="access_time"
                      v-on="on"
                      readonly
                      :disabled="form.info_lead.no_call_received"
                      :rules="[x=>isRequired(x, 'Time', form.info_lead.no_call_received)]"
                      ref="phone_resp_time"
                  ></v-text-field>
               </template>
               <v-time-picker v-model="form.info_lead.phone_response_time" ></v-time-picker>
            </v-menu>
         </v-flex>

         <v-flex grow>

            <v-checkbox
                label="Check if no call received"
                v-model="form.info_lead.no_call_received"
                v-on:change="$refs.phone_resp_time.resetValidation(); $refs.phone_resp_date.resetValidation()"
            >
            </v-checkbox>
         </v-flex>

      </v-layout>



      <v-layout md12 v-if="msg_duplicate_warning" class="pb-0" wrap>
         <v-flex xs12 shrink class="red--text">Warning, this might be a duplicate lead.  Here are the previously
            graded lead(s) that look similar:</v-flex>
         <v-flex xs12
                 class="pb-2"
                 v-for="(val, i) in lead_duplicates" :key="i"
         >
            Customer Name: {{val.info_customer.name_first}} {{val.info_customer.name_last}};
            Vehicle: {{val.info_lead.wanted_vehicle}};
            Lead Source: {{val.info_lead.lead_source}};
            Date In: {{val.info_lead.lead_arrived_date}}
         </v-flex>
      </v-layout>
   </div>

</template>







<script>
import data_getters from "@/mixins/data_getters";
import validate from "@/mixins/validation";
import curricula_common from "@/views/Curricula/curricula_common";
import axios from "axios";

export default {
   name: "formLeadInfo",
   props:{
      form: Object,
      selectedDealership: Object,//used to check for duplicates
      //picker_nudge: String,
   },

   mixins: [validate, curricula_common, data_getters],

   data(){
      return{
         // date/time picker state variables (used to toggle display state)
         date_menu1: false,
         date_menu2: false,
         date_menu3: false,

         time_menu1: false,
         time_menu2: false,
         time_menu3: false,
         lock_user: false,
         picker_nudge: 30,

         duplicate_lead_obj: {}, // used to save lead info to check for duplicates
         msg_duplicate_warning: null,
         lead_duplicates: [],
      }
   },

   methods:{
      /**
       *
       * @param fname - str, customer's first name
       * @param lname - str, customer's last name
       * @param date_in - str, date lead came in, in yyyy-mm-dd fmt
       * @returns {Promise<*>}
       */
      async get_duplicate_graded_leads({dealer_id, fname, lname, date_in}= {}){
         let {token, query} = await this.base_user_request();
         let url = this.$baseUrlApi + '/checkDuplicateLead';

         query.dealer_id = dealer_id;
         query.fname = fname;
         query.lname = lname;
         query.date_in = date_in;

         let params = {
            match: query,
         };

         try {
            let res = await axios.post(url, params, token);
            return res.data;

         }
         catch(err){
            console.log(err);
            // ans = err.response.data;
         }
      },


      async check_duplicate_lead() {

         this.msg_duplicate_warning = null;
         this.lead_duplicates = [];

         this.duplicate_lead_obj.fname = this.form.info_cust.name_first;
         this.duplicate_lead_obj.lname = this.form.info_cust.name_last;
         this.duplicate_lead_obj.date_in = this.form.info_lead.lead_arrived_date;

         let l = this.duplicate_lead_obj;

         console.log('ran lead duplicate check')
         try {
            if (l.fname !== '' && l.lname !== '' && l.date_in !== null) {
               this.duplicate_lead_obj.dealer_id = this.selectedDealership._id;

               this.lead_duplicates = await this.get_duplicate_graded_leads(l);
               if (this.lead_duplicates.length > 0) {
                  this.msg_duplicate_warning = 'Warning entered lead might be a duplicate.'
               }
            }
         } catch (err) {
            console.error(err)
         }


      },
   }
}
</script>

<style scoped>
/*.myheader{*/
/*    font-size: large;*/
/*    font-weight: bold;*/
/*    color: grey;*/
/*}*/

/*.myquestion{*/
/*    font-size: medium;*/
/*    padding-right: 5px;*/
/*}*/

.myforminput{
    /*padding-top: 5px;*/
    /*padding-bottom: 5px;*/
    padding-left: 10px;
    padding-right: 10px;

}

</style>
